import { ApiError } from '../api/transport';

type Attempt<Input> = { input: Input; key: string };
const AMBIGUOUS_HTTP_STATUSES = new Set([408, 429]);
const copy = <Value>(value: Value): Value => JSON.parse(JSON.stringify(value)) as Value;

export function isDefiniteMutationFailure(error: unknown): boolean {
  return error instanceof ApiError && error.status >= 400 && error.status < 500
    && !AMBIGUOUS_HTTP_STATUSES.has(error.status);
}

/** Keeps one JSON form operation intact until its response is known. */
export function createMutationAttempt<Input>(cloneInput: (value: Input) => Input = copy) {
  let attempt: Attempt<Input> | undefined;
  let uncertain = false;
  const cloneAttempt = (value: Attempt<Input>): Attempt<Input> => ({ key: value.key, input: cloneInput(value.input) });
  return {
    begin(input: Input): Attempt<Input> {
      attempt ??= { input: cloneInput(input), key: crypto.randomUUID() };
      return cloneAttempt(attempt);
    },
    pending(): Attempt<Input> | undefined { return attempt ? cloneAttempt(attempt) : undefined; },
    isUncertain(): boolean { return uncertain; },
    complete(): void { attempt = undefined; uncertain = false; },
    fail(error: unknown): void {
      if (!attempt) return;
      if (isDefiniteMutationFailure(error) && !uncertain) { attempt = undefined; return; }
      uncertain = true;
    },
  };
}
